import { Close, InsertDriveFile } from "@mui/icons-material";
import { Box, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import CustomCard from "components/CustomCard";
import CustomIconButton from "components/CustomIconButton";
import MediaInput from "components/files/MediaInput";
import { useEffect, useState } from "react";
import http from "../../../../http"
import { apiUrl } from "config/settings";
import useForms from "hooks/useForms";
import { endpointName } from "containers/servicesCall/const";
import { setShowLoading } from "store/sysSlice";
import { useDispatch } from "react-redux";
import useDataManager from "hooks/useDataManager";
import CustomButton from "components/CustomButton";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const Media = ({ data, setData, clearErrors, setList, list }) => {
  const { bt } = useBizTypeTranslation();
  const dispatch = useDispatch()
  const { formData } = useForms();
  const { editItem } = useDataManager();
  const theme = useTheme()
  const [mediaList, setMediaList] = useState([])
  const [loadingMap, setLoadingMap] = useState({});

  useEffect(() => {
    if (data?.media?.length > 0 && mediaList.length === 0)
      setMediaList(data?.media?.map(m => ({ ...m, init: true })))
  }, [data]);

  const handleLoaded = (id) => {
    setLoadingMap((prev) => ({ ...prev, [id]: false }));
  };

  const onUploadMedia = async (file, mediaList) => {
    dispatch(setShowLoading(true));
    const res = await http.post(`${apiUrl}/${endpointName}/media/${data.callId}`, formData({ file }))
    const newMediaList = [...mediaList, { ...res?.data?.media, url: URL.createObjectURL(file) }]
    setData(prev => ({ ...prev, media: newMediaList }))
    const newItem = { ...data, media: newMediaList }
    const newList = editItem(newItem, list);
    dispatch(setList(newList));
    setMediaList(newMediaList)
    dispatch(setShowLoading(false));
  }

  const onDeleteMedia = async (media, mediaList) => {
    dispatch(setShowLoading(true));
    const res = await http.delete(`${apiUrl}/${endpointName}/media/${data._id}/${media?._id}`);
    const newMediaList = mediaList?.filter(i => i?._id !== res?.data?.itemId)
    setData(prev => ({ ...prev, media: newMediaList }))
    const newItem = { ...data, media: newMediaList };
    const newList = editItem(newItem, list);
    dispatch(setList(newList));
    setMediaList(prev => prev?.filter(i => i?._id !== res?.data?.itemId));
    dispatch(setShowLoading(false));
  }

  return (
    <CustomCard padding={2} pb={2}>

      <Stack width="100%" direction="row" justifyContent="space-between">
        <Typography>
          {`${bt("QTY")}: ${mediaList?.length}/4`}
        </Typography>

        <MediaInput
          showLoading
          isGallery
          disabled={mediaList?.length >= 4}
          clearErrors={clearErrors}
          setCb={(file) => onUploadMedia(file, mediaList)}
          allowedFormats={["image", "video"]}
        />
      </Stack>

      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction="row"
        useFlexGap
        sx={{ flexWrap: "wrap" }}
      >
        {mediaList?.map((m, idx) => {
          const isImage = m?.mimeType?.startsWith("image/");
          const isVideo = m?.mimeType?.startsWith("video/");
          const isPdf = m?.mimeType === "application/pdf";

          const id = m._id || idx;
          const isLoading = loadingMap[id];

          return (
            <Stack position="relative" key={id}>
              <CustomIconButton
                bgcolor="error.main"
                sx={{ position: "absolute", left: { xs: 130, md: 160 }, top: -4, zIndex: 2 }}
                size={25}
                icon={<Close fontSize="small" sx={{ color: "error.text" }} />}
                onClick={() => onDeleteMedia(m, mediaList)}
              />

              <CustomCard
                width={{ xs: 150, md: 180 }}
                height={180}
                padding={1}
                justifyContent="space-between"
                sx={{ border: `2px solid ${theme.palette.primary.main}`, position: "relative" }}
              >
                {isLoading
                  ? <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "rgba(0,0,0,0.1)",
                      zIndex: 1,
                      borderRadius: 1,
                    }}
                  >
                    <CircularProgress size={24} sx={{ mb: 5 }} />
                  </Box>
                  : null
                }

                {isImage
                  ? <img
                    src={m.url}
                    onLoad={() => handleLoaded(id)}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 10,
                      objectFit: "cover",
                      overflow: "hidden",
                    }}
                  />
                  : isVideo
                    ? <video
                      src={m.url}
                      autoPlay
                      loop
                      muted
                      onLoadedData={() => handleLoaded(id)}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 10,
                        objectFit: "cover",
                        overflow: "hidden",
                      }}
                    />
                    : isPdf
                      ? <embed
                        src={m.url}
                        type="application/pdf"
                        onLoad={() => handleLoaded(id)}
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: 10,
                        }}
                      />
                      : <Stack
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                        sx={{ width: "100%", height: "100%" }}
                      >
                        <InsertDriveFile sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                        {isLoading && handleLoaded(id)}
                      </Stack>
                }

                <CustomButton
                  title="SHOW"
                  fullWidth
                  height={30}
                  onClick={() => window.open(m.url, "_blank")}
                />
              </CustomCard>
            </Stack>
          );
        })}
      </Stack>
    </CustomCard>
  )
}
export default Media